import EtchStoryWithImage from './EtchStoryWithImage.component';

export default EtchStoryWithImage;